<template>
  <div class="h-full dark">
    <RoundFilterUtils />
    <Svgs />
    <SplashComponent v-if="!canGoIntoApp" />
    <div
      v-else
      class="w-full h-full opacity-0 hidden"
      :class="{ '!block !opacity-100': canGoIntoApp }"
    >
      <div class="h-full w-full">
        <SubscriptionDirect platform="netflix" />
      </div>
      <div :key="pageContentKey">
        <TransactionDetailsComponent />
        <PaymentLinkShower />
        <PromptModal />
        <LinkOpener />
        <ChoiceModal />
        <LoadingPromptModal />
      </div>
    </div>
    <ToastNotification />
  </div>
</template>

<script>
import LinkOpener from './components/appComponent/LinkOpener.vue'
import SplashComponent from './components/appComponent/SplashComponent.vue'
import PaymentLinkShower from './components/transaction/PaymentLinkShower.vue'
import TransactionDetailsComponent from './components/transaction/TransactionDetailsComponent.vue'
import ChoiceModal from './components/utils/ChoiceModal.vue'
import LoadingPromptModal from './components/utils/LoadingPromptModal.vue'
import PromptModal from './components/utils/PromptModal.vue'
import ToastNotification from './components/utils/ToastNotification.vue'
import RoundFilterUtils from './components/utils/RoundFilterUtils.vue'
import SubscriptionDirect from './components/transaction/transactionLaunch/SubscriptionDirect.vue'
import Svgs from './components/utils/Svgs.vue'

export default {
  name: 'App',
  metaInfo: {
    link: [],
  },
  components: {
    PromptModal,
    ToastNotification,
    TransactionDetailsComponent,
    SplashComponent,
    LoadingPromptModal,
    ChoiceModal,
    LinkOpener,
    PaymentLinkShower,
    RoundFilterUtils,
    SubscriptionDirect,
    Svgs,
  },
  data() {
    return {
      pageContentKey: 'initial',
      appInitialized: false,
      pages: [
        {
          path: '',
          requirements: [],
          redirectTo: [],
          themeColor: {
            '': '#242c3b',
            '#bottomsheet': '#181E29',
            '#modalvisible': '#181E29',
            '#tourguide': '#181E29',
            '#chat': '#fff',
          },
        },
      ],
      userTheme: 'light',
    }
  },
  beforeMount() {
    // this.$router.push({ path: "/", replace: true }).catch(() => {});
  },
  async mounted() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    await this.initializeApp()
    this.initListeners()
    this.loadLottiePlayer()
    this.tryEnableLogs()
    setTimeout(() => {
      this.startSubscription()
    }, 500)
  },
  beforeUnmount() {},
  methods: {
    startSubscription() {
      console.log('f')
      // this.$Events.dispatchEvent('service_launching_requested', {serviceId: 'subscription'})
    },
    tryEnableLogs() {
      let isClient = false
      try {
        if (window) isClient = true
      } catch (error) {
        console.log(error)
      }
      if (!isClient) return
      if (this.$router?.query?.enableLogs) window.console = window.realConsole
    },
    async initializeApp() {
      // this.saveReferralCode()
      // await this.$router.push('/').catch(e => {})
      // await this.$router.push('/#initiating').catch(e => {})
      // const userConnected = this.$QuickStorage.getStored('user_connected')
      // if (userConnected) this.listenWorkerInitiated()
      // await this.handleRoute()
      // setTimeout(() => {
      //   this.appInitialized = true
      // this.handleRoute()
      // }, 1000)
    },
    saveReferralCode() {
      const referralCode = this.$route.query?.ref
      if (!referralCode) return
      this.$QuickStorage.storeData('referralCode', referralCode)
    },
    async handleRoute(newRoute = this.$route) {
      return
      // let page = this.pages.find(page => page.path == newRoute.path)
      // if (!page) page = this.pages[0]

      // this.resetThemeColor(page)
      // let requirementNotMetIndex = -1
      // await Promise.all(
      //   page.requirements.map(async (requirement, index) => {
      //     if (requirementNotMetIndex !== -1) return
      //     if (await this.requirementMet(requirement)) return
      //     requirementNotMetIndex = index
      //     return
      //   }),
      // )
      // const redirection = page.redirectTo[requirementNotMetIndex]
      // if (redirection) {
      //   await this.$router.push(redirection).catch(e => {})
      // } else if (page.path !== newRoute.path) {
      //   await this.$router.push(page.path).catch(e => {})
      // }
    },
    async requirementMet(requirement) {
      if (requirement == 'userConnected') {
        const userConnected = this.$QuickStorage.getStored('user_connected')
        return userConnected
      } else if (requirement == 'userNotConnected') {
        const userConnected = this.$QuickStorage.getStored('user_connected')
        return !userConnected
      } else if (requirement == 'appUpToDate') {
        return await this.appIsUpToDate()
      } else if (requirement == 'appNotUpToDate') {
        return !(await this.appIsUpToDate())
      }
    },
    async appIsUpToDate() {
      if (!window.isIframe) return true
      const appVersionData = await this.$Events.sendDataRequestResolve(
        'andoidApkVersion',
        {},
        1000,
      )
      if (!appVersionData?.version) return false
      return appVersionData?.version >= 6
    },
    listenWorkerInitiated() {
      const reloadingPageTimeoutId = setTimeout(() => {
        window.location.reload()
      }, 10000)
      const pingInterval = setInterval(() => {
        this.$Events.sendDataRequest('pingWorker', () => {
          clearTimeout(reloadingPageTimeoutId)
          clearInterval(pingInterval)
          this.checkUserConnectionData()
        })
      }, 1000)
    },

    async checkUserConnectionData() {
      const userData = await this.$Events.sendDataRequestResolve('userData')
      if (!userData?.email) {
        this.$Events.dispatchEvent('logout_requested')
      } else this.$Events.dispatchEvent('user_connected', userData)
      // this.displayedProject = this.$Controller.getDisplayedProject();
    },
    initListeners() {
      this.$Events.handleEvent('login_requested', () => {
        const reloadTimeout = setTimeout(() => {
          window.location.reload()
        }, 3000)
        this.$Events.sendDataRequest('pingWorker', () => {
          clearTimeout(reloadTimeout)
        })
      })
      this.$Events.handleEvent('registration_requested', () => {
        const reloadTimeout = setTimeout(() => {
          window.location.reload()
        }, 3000)
        this.$Events.sendDataRequest('pingWorker', () => {
          clearTimeout(reloadTimeout)
        })
      })
      this.$Events.handleEvent('logout_requested', () => {
        this.$router.push('/login')
        this.$Events.dispatchEvent('clean_all_data_requested')
      })
      this.$Events.handleEvent('logout_done', () => {
        this.$router.push('/login')
      })
      this.$Events.handleEvent(
        'ask_notification_permission_to_user_required',
        () => {
          this.$router.push('/acceptnotification')
        },
      )
      this.$Events.handleEvent('single_transaction_updated', transaction => {
        if (transaction?.status !== 'pending') return
        const paymentUrl = transaction?.paymentUrl
        if (!paymentUrl) return
        if (!window.openedUrls) window.openedUrls = []
        if (window.openedUrls.includes(paymentUrl)) return
        window.open(paymentUrl, '_blank')
        window.openedUrls.push(paymentUrl)
      })
      this.$Events.handleEvent('notification_action_click', notifData => {
        const { data, actionButtonIndex } = notifData
        const matchingAction = (data.actions || [])[actionButtonIndex || 0]
        if (matchingAction.url) {
          window.open(matchingAction.url, '_blank')
        }
        if (matchingAction.recharge1xBet) {
          this.$Events.dispatchEvent('service_launching_requested', {
            serviceId: '1xbet',
          })
        }
        if (matchingAction.rechargeBetwinner) {
          this.$Events.dispatchEvent('service_launching_requested', {
            serviceId: 'betwinner',
          })
        }
        if (matchingAction.rechargeMelbet) {
          this.$Events.dispatchEvent('service_launching_requested', {
            serviceId: 'melbet',
          })
        }
        if (matchingAction.matchList) {
          this.$Events.dispatchEvent('show_match_list', data.matches)
        }
      })
      this.$Events.handleEvent('deposit_action_requested', () => {
        document.querySelector('#home_navigation_mainHome').click()
        setTimeout(() => {
          this.$Events.dispatchEvent('required_tour_guide', { id: 'service' })
        }, 800)
      })
      this.$Events.handleEvent(
        'vip_subscription_section_display_required',
        () => {
          document.querySelector('#home_navigation_coupons').click()
          setTimeout(() => {
            document.querySelector('#tab_vip').click()
          }, 1000)
        },
      )
      this.$Events.handleEvent('lang_changed', () => {
        // this.key = Date.now();
        this.$forceUpdate()
      })
      this.$Events.handleEvent('color_theme_changed', () => {
        this.key = Date.now()
        // this.$forceUpdate();
      })
      this.$Events.handleEvent('user_not_updated', () => {
        this.$Events.dispatchEvent('toast_notification', {
          body: "Nous n'arrivons pas à mettre à jour les infos de votre compte. Veuillez réessayer",
          type: 'warning',
          title: 'Echec',
        })
      })
      this.$Events.handleEvent('user_data_updated', () => {
        this.$Events.dispatchEvent('toast_notification', {
          body: 'Les infos de votre compte ont été mises à jour correctement',
          type: 'success',
        })
      })
    },
    addPicErrorListener() {
      let isClient = false
      try {
        if (window) isClient = true
      } catch (error) {
        console.log(error)
      }
      if (!isClient) return
      const picsNotWathingError = document.querySelectorAll(
        'img:not([watchimageerror])',
      )
      picsNotWathingError.forEach(pic => {
        pic.addEventListener('error', () => {
          pic.setAttribute('goterror', 'true')
        })
        pic.setAttribute('watchimageerror', 'false')
        pic.setAttribute('onerror', 'this.style.opacity = 0')
      })
    },
    loadLottiePlayer() {
      const scriptSelector = 'script[name="lottieScript"]'
      const lottieScriptAlreadyAdded = document.querySelector(scriptSelector)
      if (lottieScriptAlreadyAdded) return
      const lottieScript = document.createElement('script')
      lottieScript.setAttribute('name', 'lottieScript')
      lottieScript.setAttribute('src', '/plugins/lottie-player.js')
      document.head.appendChild(lottieScript)
    },
    resetThemeColor(pageData) {
      if (!this.appInitialized) return
      const hash = this.$route.hash || ''

      let themeColor = pageData.themeColor['']
      Object.keys(pageData.themeColor).forEach(pageHash => {
        const hashMatch = new RegExp(pageHash).test(hash)
        if (!hashMatch) return
        themeColor = pageData.themeColor[pageHash]
      })
      console.log(themeColor)
      if (themeColor) {
        this.$Commons.setThemeColor(themeColor)
      }

      let bottomNavColor
      if (pageData.bottomNavColor) pageData.bottomNavColor['']
      Object.keys(pageData.bottomNavColor || {}).forEach(pageHash => {
        const hashMatch = new RegExp(pageHash).test(hash)
        if (!hashMatch) return
        bottomNavColor = pageData.themeColor[pageHash]
      })
      if (bottomNavColor) {
        document.body.style.backgroundColor = bottomNavColor
      } else {
        document.body.style.removeProperty('background-color')
      }
    },
  },

  computed: {
    canGoIntoApp() {
      return true
      return this.appInitialized
    },
  },
  watch: {
    $route: {
      deep: true,
      async handler(newValue) {
        this.handleRoute(newValue)
      },
    },
    canGoIntoApp() {
      this.$Events.dispatchEvent('app_initialized')
    },
  },
}
</script>
<!-- 
<style>
:root {
  /*Input components*/
  --inputcomponent-height: 55px;
  --inputcomponent-margin-top: 10px;
  --inputcomponent-margin-bottom: 10px;
  --inputcomponent-background-color: #242c3b22;
  /* --inputcomponent-background-color: #fff8; */
  --inputcomponent-border-color: #0000;
  --inputcomponent-border: solid 2px var(--inputcomponent-border-color);
  --inputcomponent-border-radius: 1.4rem;
  --inputcomponent-width: 100%;
  --inputcomponent-focus-label-color: var(--title-description-color);
  --inputcomponent-label-position-top: 14px;
  --inputcomponent-label-font-size: 14px;
  --inputcomponent-focus-label-font-size: 12px;
}

</style> -->
